"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttackingMidfielderRoleBonuses = exports.AttackingMidfielderExpandedRoles = void 0;
const playerBonuses_1 = require("../playerBonuses"); // Ensuring this import is present
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var AttackingMidfielderExpandedRoles;
(function (AttackingMidfielderExpandedRoles) {
    //New & confirmed roles
    // --- Uncommon --- GENERIC
    AttackingMidfielderExpandedRoles["RAPID_ATTACKING_MIDFIELDER"] = "RAPID_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["POWERFUL_ATTACKING_MIDFIELDER"] = "POWERFUL_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["TIRELESS_ATTACKING_MIDFIELDER"] = "TIRELESS_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["DETERMINED_ATTACKING_MIDFIELDER"] = "DETERMINED_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["HEROIC_ATTACKING_MIDFIELDER"] = "HEROIC_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["ECCENTRIC_ATTACKING_MIDFIELDER"] = "ECCENTRIC_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["RELIABLE_ATTACKING_MIDFIELDER"] = "RELIABLE_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["LUCKY_ATTACKING_MIDFIELDER"] = "LUCKY_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["STUBBORN_ATTACKING_MIDFIELDER"] = "STUBBORN_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["TENACIOUS_ATTACKING_MIDFIELDER"] = "TENACIOUS_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["INSPIRATIONAL_ATTACKING_MIDFIELDER"] = "INSPIRATIONAL_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["DOMINANT_ATTACKING_MIDFIELDER"] = "DOMINANT_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["IMPACT_ATTACKING_MIDFIELDER"] = "IMPACT_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["PRESSING_ATTACKER"] = "PRESSING_ATTACKER";
    AttackingMidfielderExpandedRoles["EXPERIENCED_ATTACKING_MIDFIELDER"] = "EXPERIENCED_ATTACKING_MIDFIELDER";
    //Uncommon attacking
    AttackingMidfielderExpandedRoles["STAR_ATTACKING_MIDFIELDER"] = "STAR_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["SILKY_ATTACKING_MIDFIELDER"] = "SILKY_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["LETHAL_ATTACKING_MIDFIELDER"] = "LETHAL_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["PENETRATING_ATTACKING_MIDFIELDER"] = "PENETRATING_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["PROLIFIC_ATTACKING_MIDFIELDER"] = "PROLIFIC_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["VOCAL_ATTACKING_MIDFIELDER"] = "VOCAL_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["ROAMING_ATTACKING_MIDFIELDER"] = "ROAMING_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["ORCHESTRATING_ATTACKING_MIDFIELDER"] = "ORCHESTRATING_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["ADVANCED_PLAYMAKER"] = "ADVANCED_PLAYMAKER";
    AttackingMidfielderExpandedRoles["ATTACKING_OUTLET"] = "ATTACKING_OUTLET";
    AttackingMidfielderExpandedRoles["FIREY_ATTACKING_MIDFIELDER"] = "FIREY_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["VERSATILE_ATTACKING_MIDFIELDER"] = "VERSATILE_ATTACKING_MIDFIELDER";
    // RARE GENERIC
    AttackingMidfielderExpandedRoles["ENERGETIC_ATTACKING_MIDFIELDER"] = "ENERGETIC_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["ATHLETIC_ATTACKING_MIDFIELDER"] = "ATHLETIC_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["PLUCKY_ATTACKING_MIDFIELDER"] = "PLUCKY_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["VALIANT_ATTACKING_MIDFIELDER"] = "VALIANT_ATTACKING_MIDFIELDER";
    AttackingMidfielderExpandedRoles["GEGEN_PRESSING_ATTACKER"] = "GEGEN_PRESSING_ATTACKER";
    AttackingMidfielderExpandedRoles["ROUSING_ATTACKER"] = "ROUSING_ATTACKER";
    //RARE Position specific
    AttackingMidfielderExpandedRoles["ARTIST"] = "ARTIST";
    AttackingMidfielderExpandedRoles["MAESTRO"] = "MAESTRO";
    AttackingMidfielderExpandedRoles["CATALYST"] = "CATALYST";
    AttackingMidfielderExpandedRoles["ENGANCHE"] = "ENGANCHE";
    AttackingMidfielderExpandedRoles["TREQUARTISTA"] = "TREQUARTISTA";
    AttackingMidfielderExpandedRoles["LUXURY_PLAYER"] = "LUXURY_PLAYER";
})(AttackingMidfielderExpandedRoles || (exports.AttackingMidfielderExpandedRoles = AttackingMidfielderExpandedRoles = {}));
exports.AttackingMidfielderRoleBonuses = {
    [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            pass: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            run: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            shoot: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.MIDFIELD, zones_1.Zones.ATTACK],
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [AttackingMidfielderExpandedRoles.RAPID_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [AttackingMidfielderExpandedRoles.POWERFUL_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [AttackingMidfielderExpandedRoles.TIRELESS_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [AttackingMidfielderExpandedRoles.DETERMINED_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [AttackingMidfielderExpandedRoles.HEROIC_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [AttackingMidfielderExpandedRoles.ECCENTRIC_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [AttackingMidfielderExpandedRoles.RELIABLE_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [AttackingMidfielderExpandedRoles.LUCKY_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [AttackingMidfielderExpandedRoles.STUBBORN_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Unyielding is defensive; for AM, nominal pass bonus
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [AttackingMidfielderExpandedRoles.TENACIOUS_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [AttackingMidfielderExpandedRoles.INSPIRATIONAL_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [AttackingMidfielderExpandedRoles.DOMINANT_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [AttackingMidfielderExpandedRoles.IMPACT_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [AttackingMidfielderExpandedRoles.PRESSING_ATTACKER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PRESSING],
    },
    [AttackingMidfielderExpandedRoles.EXPERIENCED_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    // --- Uncommon attacking ---
    [AttackingMidfielderExpandedRoles.STAR_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [AttackingMidfielderExpandedRoles.SILKY_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [AttackingMidfielderExpandedRoles.LETHAL_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LETHAL],
    },
    [AttackingMidfielderExpandedRoles.PENETRATING_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE],
    },
    [AttackingMidfielderExpandedRoles.PROLIFIC_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.GOAL_MACHINE],
    },
    [AttackingMidfielderExpandedRoles.VOCAL_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [AttackingMidfielderExpandedRoles.ROAMING_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HALF_SPACES],
    },
    [AttackingMidfielderExpandedRoles.ADVANCED_PLAYMAKER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [AttackingMidfielderExpandedRoles.ORCHESTRATING_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    [AttackingMidfielderExpandedRoles.ATTACKING_OUTLET]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.TARGET],
    },
    [AttackingMidfielderExpandedRoles.FIREY_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [AttackingMidfielderExpandedRoles.VERSATILE_ATTACKING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.ATTACKING_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // 3rd position attribute
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- RARE GENERIC ---
    [AttackingMidfielderExpandedRoles.ENERGETIC_ATTACKING_MIDFIELDER]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.RAPID_ATTACKING_MIDFIELDER,
            AttackingMidfielderExpandedRoles.TIRELESS_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [], // Inherits RAPID, STAMINA from parents
    },
    [AttackingMidfielderExpandedRoles.ATHLETIC_ATTACKING_MIDFIELDER]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.RAPID_ATTACKING_MIDFIELDER,
            AttackingMidfielderExpandedRoles.POWERFUL_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Could be shoot too, run covers general athleticism
        positionsEnabled: [],
        playerTraits: [], // Inherits RAPID, POWERFUL from parents
    },
    [AttackingMidfielderExpandedRoles.PLUCKY_ATTACKING_MIDFIELDER]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.LUCKY_ATTACKING_MIDFIELDER,
            AttackingMidfielderExpandedRoles.TENACIOUS_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Tenacity from Underdog
        positionsEnabled: [],
        playerTraits: [], // Inherits LUCKY, UNDERDOG from parents
    },
    [AttackingMidfielderExpandedRoles.VALIANT_ATTACKING_MIDFIELDER]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.DETERMINED_ATTACKING_MIDFIELDER,
            AttackingMidfielderExpandedRoles.HEROIC_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Combination of determination and heroism leading to impact
        positionsEnabled: [],
        playerTraits: [], // Inherits DETERMINED, HERO from parents
    },
    [AttackingMidfielderExpandedRoles.GEGEN_PRESSING_ATTACKER]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.PRESSING_ATTACKER,
            AttackingMidfielderExpandedRoles.ORCHESTRATING_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [], // Inherits PRESSING, SHORT_PASS from parents
    },
    [AttackingMidfielderExpandedRoles.ROUSING_ATTACKER]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.INSPIRATIONAL_ATTACKING_MIDFIELDER,
            AttackingMidfielderExpandedRoles.DETERMINED_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [], // Inherits INSPIRATIONAL, DETERMINED from parents
    },
    // --- RARE Position specific ---
    [AttackingMidfielderExpandedRoles.CATALYST]: {
        parentRoles: [
            AttackingMidfielderExpandedRoles.ADVANCED_PLAYMAKER,
            AttackingMidfielderExpandedRoles.DETERMINED_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Primarily a playmaker
        positionsEnabled: [],
        playerTraits: [], // Inherits PLAYMAKER, DETERMINED from parents
    },
    [AttackingMidfielderExpandedRoles.ENGANCHE]: {
        // Playmaker + HALF_SPACES trait
        parentRoles: [
            AttackingMidfielderExpandedRoles.ADVANCED_PLAYMAKER,
            AttackingMidfielderExpandedRoles.ECCENTRIC_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Playmaker operating in half spaces
        positionsEnabled: [],
        playerTraits: [], // Inherits PLAYMAKER from parent, adds HALF_SPACES
    },
    [AttackingMidfielderExpandedRoles.TREQUARTISTA]: {
        // Playmaker + Lethal
        parentRoles: [
            AttackingMidfielderExpandedRoles.ROAMING_ATTACKING_MIDFIELDER,
            AttackingMidfielderExpandedRoles.LETHAL_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // A playmaker known for goal threat
        positionsEnabled: [],
        playerTraits: [], // Inherits PLAYMAKER, LETHAL from parents
    },
    [AttackingMidfielderExpandedRoles.LUXURY_PLAYER]: {
        // Playmaker + Flair
        parentRoles: [
            AttackingMidfielderExpandedRoles.ADVANCED_PLAYMAKER,
            AttackingMidfielderExpandedRoles.ECCENTRIC_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Playmaker with flair
        positionsEnabled: [],
        playerTraits: [], // Inherits PLAYMAKER, FLAIR from parent
    },
    [AttackingMidfielderExpandedRoles.ARTIST]: {
        // Playmaker + First Touch
        parentRoles: [
            AttackingMidfielderExpandedRoles.ADVANCED_PLAYMAKER,
            AttackingMidfielderExpandedRoles.SILKY_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Playmaker with exceptional control
        positionsEnabled: [],
        playerTraits: [], // Inherits PLAYMAKER, FIRST_TOUCH from parent
    },
    [AttackingMidfielderExpandedRoles.MAESTRO]: {
        // Playmaker + Organised
        parentRoles: [
            AttackingMidfielderExpandedRoles.ADVANCED_PLAYMAKER,
            AttackingMidfielderExpandedRoles.VOCAL_ATTACKING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Playmaker who dictates tempo
        positionsEnabled: [],
        playerTraits: [], // Inherits PLAYMAKER, ORGANISED from parent
    },
};
